import type { FaireProductEntity } from "../../entity_types/product";

export const p_8gaxqab3q5: FaireProductEntity = {
  token: "p_8gaxqab3q5",
  type: "product",
  name: "COIN POUCH FLOWER MARKET POPPY",
  brandToken: "b_3s38anh4bi",
  brandName: "Lady Jayne",
  imageUrl:
    "https://cdn.faire.com/fastly/73c45862a2dfb88375e27dd0d6704daa616036932edb89e73c7f79b96c63265c.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.96,
  description:
    'Embroidered canvas pouch with lining and gold metal zipper pull.\n5" x 3.5"',
  tags: [],
  msrpDollars: 21.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:39.010Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
